import { createAction, props } from "@ngrx/store";
import { OtpVerifyPayload, RegistrationPayload, SsoExchangePayload } from "./auth.models";

export const RegisterRequest = createAction('[Auth] Register Organization', props<{ payload: RegistrationPayload }>());
export const RegisterSuccess = createAction('[Auth] Register Organization Success');
export const RegisterFailure = createAction('[Auth] Register Organization Failure', props<{ error: string }>());

export const VerifyOtpRequest = createAction('[Auth] Verify OTP', props<{ payload: OtpVerifyPayload }>());
export const VerifyOtpSuccess = createAction('[Auth] Verify OTP Success');
export const VerifyOtpFailure = createAction('[Auth] Verify OTP Failure', props<{ error: string }>());

export const ResendOtpRequest = createAction('[Auth] Resend OTP', props<{ payload: { phone: string } }>());
export const ResendOtpSuccess = createAction('[Auth] Resend OTP Success');
export const ResendOtpFailure = createAction('[Auth] Resend OTP Failure', props<{ error: string }>());

export const LoginRequest = createAction('[Auth] Login Requested', props<{ payload: { phone: string; password: string } }>());
export const LoginSuccess = createAction('[Auth] Login Success', props<{ token: string; }>());
export const LoginFailure = createAction('[Auth] Login Failure', props<{ error: string }>());

export const RefreshTokenRequest = createAction('[Auth] Refresh Token Requested');
export const RefreshTokenSuccess = createAction('[Auth] Refresh Token Success', props<{ token: string; }>());
export const RefreshTokenFailure = createAction('[Auth] Refresh Token Failure', props<{ error: string }>());

export const ForgotPasswordRequest = createAction('[Auth] Forgot Password Requested', props<{ payload: { phone: string } }>());
export const ForgotPasswordSuccess = createAction('[Auth] Forgot Password Success');
export const ForgotPasswordFailure = createAction('[Auth] Forgot Password Failure', props<{ error: string }>());

export const ResetPasswordRequest = createAction('[Auth] Reset Password Requested', props<{ payload: { token: string; password: string } }>());
export const ResetPasswordSuccess = createAction('[Auth] Reset Password Success');
export const ResetPasswordFailure = createAction('[Auth] Reset Password Failure', props<{ error: string }>());

export const LogoutRequest = createAction('[Auth] Logout Requested');
export const LogoutSuccess = createAction('[Auth] Logout Success');
export const LogoutFailure = createAction('[Auth] Logout Failure', props<{ error: string }>());

export const ChangePasswordRequest = createAction('[Auth] Change Password Requested', props<{ payload: { old_password: string; new_password: string } }>());
export const ChangePasswordSuccess = createAction('[Auth] Change Password Success');
export const ChangePasswordFailure = createAction('[Auth] Change Password Failure', props<{ error: string }>());

export const SetPasswordRequest = createAction('[Auth] Set Password Requested', props<{ payload: { token: string; password: string } }>());
export const SetPasswordSuccess = createAction('[Auth] Set Password Success');
export const SetPasswordFailure = createAction('[Auth] Set Password Failure', props<{ error: string }>());

export const SsoExchangeRequest = createAction('[Auth] SSO Exchange Requested', props<{ payload: SsoExchangePayload }>());
export const SsoExchangeSuccess = createAction('[Auth] SSO Exchange Success', props<{ token: string }>());
export const SsoExchangeFailure = createAction('[Auth] SSO Exchange Failure', props<{ error: string }>());

export const AuthValidationError = createAction('[Auth] Validation Error', props<{ validationError:any[] }>());
